import React, { useState } from 'react';
import { Calendar, Navigation, Users, CheckCircle, Loader2, ChevronRight } from 'lucide-react';
import { BookingDetailModal } from './BookingDetailModal';

export function DriverBookings({ t, bookings, formatDate, formatLocation, onComplete, completingTransfer }) {
  const [selectedBooking, setSelectedBooking] = useState(null);

  if (bookings.length === 0) {
    return (
      <div className="bg-white border border-slate-200 rounded-lg p-12 text-center text-slate-400">
        <CheckCircle size={32} className="mx-auto mb-2 opacity-50" />
        <p>{t('driver_no_bookings')}</p>
      </div>
    );
  }

  return (
    <>
      <div className="space-y-4">
        {bookings.map(booking => (
          <div
            key={booking.id}
            onClick={() => setSelectedBooking(booking)}
            className="bg-white border border-slate-200 rounded-xl p-5 hover:border-orange-300 hover:shadow-md cursor-pointer transition-all"
            data-testid={`booking-card-${booking.id}`}
          >
            <div className="flex items-start justify-between">
              <div className="flex-1">
                <div className="flex items-start gap-3 mb-3">
                  <div className="flex flex-col items-center">
                    <div className="w-2.5 h-2.5 rounded-full bg-orange-500" />
                    <div className="w-0.5 h-5 bg-slate-200" />
                    <div className="w-2.5 h-2.5 rounded-full bg-emerald-500" />
                  </div>
                  <div>
                    <p className="text-sm text-slate-800">{formatLocation(booking.transfer?.pickup_location)}</p>
                    <p className="text-sm text-slate-800 mt-3">{formatLocation(booking.transfer?.dropoff_location)}</p>
                  </div>
                </div>
                <div className="flex flex-wrap gap-3 text-xs text-slate-500">
                  <span className="flex items-center gap-1"><Calendar size={12} /> {booking.transfer?.pickup_date ? formatDate(booking.transfer.pickup_date) : ''}</span>
                  <span className="flex items-center gap-1"><Navigation size={12} /> {booking.transfer?.distance_km} km</span>
                  <span className="flex items-center gap-1"><Users size={12} /> {(booking.transfer?.adults || 0) + (booking.transfer?.children || 0)} Pers.</span>
                  <span className="font-semibold text-emerald-600">&euro;{booking.price}</span>
                </div>
              </div>
              <div className="text-right flex flex-col items-end gap-2 ml-3">
                <span className={`px-3 py-1 rounded-lg text-xs font-medium ${
                  booking.transfer?.status === 'completed'
                    ? 'bg-slate-100 text-slate-600'
                    : 'bg-emerald-100 text-emerald-700'
                }`}>
                  {booking.transfer?.status === 'completed' ? t('driver_status_completed') : t('driver_status_booked')}
                </span>
                {booking.transfer?.status === 'booked' && (
                  <button
                    onClick={(e) => { e.stopPropagation(); onComplete(booking.transfer_id); }}
                    disabled={completingTransfer === booking.transfer_id}
                    className="px-4 py-2 bg-slate-800 text-white rounded-lg text-sm font-medium hover:bg-slate-900 transition-colors disabled:opacity-50 flex items-center gap-1.5"
                    data-testid={`complete-btn-${booking.transfer_id}`}
                  >
                    {completingTransfer === booking.transfer_id ? (
                      <Loader2 size={14} className="animate-spin" />
                    ) : (
                      <>
                        <CheckCircle size={14} />
                        {t('driver_complete_btn')}
                      </>
                    )}
                  </button>
                )}
                <ChevronRight size={16} className="text-slate-300 mt-1" />
              </div>
            </div>
          </div>
        ))}
      </div>

      {selectedBooking && (
        <BookingDetailModal
          booking={selectedBooking}
          onClose={() => setSelectedBooking(null)}
          t={t}
        />
      )}
    </>
  );
}
